import { Card, CardContent, Stack, Typography } from '@mui/material';
import ColouredLabelBox from 'domains/core/components/ColouredLabelBox';
import type { AccessCentreUserDetail } from 'domains/accessCentre/types';

const cardRootStyles = {
    width: '100%',
};

const cardContentStackStyles = {
    spacing: 3,
    mt: 2,
};

const fieldRowStyles = {
    direction: 'row' as const,
    spacing: 4,
    flexWrap: 'wrap' as const,
};

const fieldItemStyles = {
    flex: 1,
    minWidth: 200,
};

export type UserInformationCardProps = {
    user: AccessCentreUserDetail;
};

const UserInformationCard = ({ user }: UserInformationCardProps) => (
    <Card variant="outlined" sx={cardRootStyles} data-testid="access-center-user-information-card">
        <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
                User Information
            </Typography>
            <Stack spacing={cardContentStackStyles.spacing} sx={{ mt: cardContentStackStyles.mt }}>
                <Stack {...fieldRowStyles}>
                    <Stack sx={fieldItemStyles}>
                        <Typography variant="body2" color="text.secondary">
                            Name
                        </Typography>
                        <Typography variant="body1">{user?.name || '—'}</Typography>
                    </Stack>
                    <Stack sx={fieldItemStyles}>
                        <Typography variant="body2" color="text.secondary">
                            Email
                        </Typography>
                        <Typography variant="body1">{user?.email || '—'}</Typography>
                    </Stack>
                </Stack>
                <Stack {...fieldRowStyles}>
                    <Stack sx={fieldItemStyles}>
                        <Typography variant="body2" color="text.secondary">
                            Current role
                        </Typography>
                        <ColouredLabelBox color="primary" dataTestId="access-center-user-current-role">
                            {user?.role_name || '—'}
                        </ColouredLabelBox>
                    </Stack>
                </Stack>
            </Stack>
        </CardContent>
    </Card>
);

export default UserInformationCard;
